module.exports = __webpack_public_path__ + "assets/img/navigation_play.svg";